module.exports = __webpack_public_path__ + "static/coinbase-group-9d7c130b9220fc7d93e02a00d84e620e.png";